import { useEffect, useState } from 'react'
import { useAuthStore } from '@/stores/auth'

const BOARD_TOKEN = 'urlzippy-6kzwh'
const PORTAL_BASE_URL = `https://looply-web.vercel.app/portal/${BOARD_TOKEN}`

async function fetchSsoToken(accessToken: string): Promise<string | null> {
  try {
    const res = await fetch('/api/feedback/sso-token', {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    if (!res.ok) return null
    const data = await res.json()
    return data.ssoToken ?? null
  } catch {
    return null
  }
}

export function FeedbackPage() {
  const { user, session } = useAuthStore()
  const [iframeUrl, setIframeUrl] = useState<string | null>(null)

  useEffect(() => {
    if (!user || !session) return

    ;(async () => {
      const ssoToken = await fetchSsoToken(session.access_token)
      const params = new URLSearchParams()
      if (ssoToken) params.append('sso_token', ssoToken)
      params.append('theme', 'dark')
      setIframeUrl(`${PORTAL_BASE_URL}?${params.toString()}`)
    })()
  }, [user, session])

  return (
    <div className="w-full h-[calc(100vh-140px)] min-h-[600px] flex flex-col">
      <div className="flex-1 bg-white dark:bg-[#18181b] rounded-xl shadow-sm border border-[#e7ebf3] dark:border-white/10 overflow-hidden relative">
        {!iframeUrl && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="flex flex-col items-center gap-3">
              <div className="w-8 h-8 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin" />
              <p className="text-sm text-gray-500 dark:text-gray-400">Loading feedback portal…</p>
            </div>
          </div>
        )}
        {iframeUrl && (
          <iframe
            src={iframeUrl}
            width="100%"
            height="100%"
            style={{ border: 'none', borderRadius: '12px' }}
            title="Feedback Portal"
          />
        )}
      </div>
    </div>
  )
}
